// ============================================
// SISTEMA DE PERMISOS — Frontend
// ============================================
// PERM-2 (FASE A0): reescritura completa para alinearlo con el formato JSONB
// real de BD (modulo.submodulo: true).
//
// Modelo:
// - usuario.permisos es un objeto plano: { "modulo.submodulo": true, ... }
// - Solo el rol 'direccion' tiene acceso TOTAL automatico (sin necesidad de keys)
// - Todos los demas roles solo ven lo que tienen marcado explicitamente
// - El admin (direccion/administracion) gestiona los permisos en /Usuarios

// PERM-1: roles vienen del catalogo unico
export { ROLES, ROLES_LABELS, ROLES_LISTA } from './roles';
import { ROLES } from './roles';

// ============================================
// CATALOGO DE MODULOS DEL SISTEMA
// ============================================
// Espejo del MODULOS de Usuarios.js. Cada submodulo se representa como
// "moduloId.submoduloId" en el JSONB de permisos.
// NOTA: Usuarios.js usa la key "subs" para el array de hijos (su propia copia
// del catalogo). Aqui se llama "submodulos" por claridad semantica. Cuando
// PERM-3 unifique el menu del Dashboard, deberiamos consolidar a una sola
// fuente y eliminar la duplicacion.
export const MODULOS = [
  { id: 'mitrabajo', label: 'Mi Trabajo', submodulos: [
    { id: 'midia',    label: 'Mi dia' },
    { id: 'agenda',   label: 'Mi agenda' },
    { id: 'tareas',   label: 'Mis tareas' },
    { id: 'gastos',   label: 'Mis gastos' },
    { id: 'agentes',  label: 'Mis agentes' },
    // TRANSPARENCIA-TOTAL (2026-07-09): permiso delegable del switch "Ver todos"
    // de la bandeja Mi Trabajo (supervision: bandeja de TODA la empresa). De facto
    // solo direccion (accesoTotal), pero administrable desde Usuarios (politica de
    // la matriz granular: ningun gate vive solo en el rol).
    { id: 'vertodos', label: 'Ver todos (supervision)' },
  ]},
  { id: 'operaciones', label: 'Expedientes', submodulos: [
    { id: 'expedientes-todos', label: 'Todos los expedientes' },
    // EXPEDIENTES-RESUMEN (2026-09-17): la tercera vista (cifras de TODA la empresa) y el permiso
    // para ver montos de expedientes ajenos. Espejo de Usuarios.js; el candado de verdad esta en el
    // servidor (middlewares/permisosUsuario.js), esto solo decide que se DIBUJA.
    { id: 'resumen-empresa',   label: 'Resumen de la empresa (cifras globales)' },
    { id: 'montos-todos',      label: 'Ver montos de expedientes ajenos' },
    // CIERRE-CON-PERMISO (2026-09-28): cerrar como ganado deja de estar cableado al rol.
    // Quien lo tenga marcado cierra por las DOS vias: el boton y el avance automatico al
    // registrar la factura. Direccion pasa siempre.
    { id: 'cerrar-ganado',     label: 'Cerrar expedientes como ganados' },
    { id: 'calendario',        label: 'Calendario' },
    // CONTRATISTAS-EXTERNOS (2026-10-14): alta y expediente de cuadrillas externas y su gente.
    { id: 'contratistas',      label: 'Contratistas externos' },
    { id: 'servicios',         label: 'Servicios del dia' },
    { id: 'mantenimientos',    label: 'Mantenimientos' },
    { id: 'programar',         label: 'Programar servicio' },
    { id: 'nueva-instalacion', label: 'Nueva instalacion' },
    { id: 'levantamientos',    label: 'Levantamientos' },
  ]},
  // TRANSPARENCIA-TOTAL (2026-07-09): el modulo suelto "Control de Expedientes" se
  // ELIMINO. Su resumen + Kanban se fusionaron dentro de Expedientes, abierto a todos.
  // Ya no existe el permiso control-expedientes.panel.
  // SUB-ALMACENES (2026-10-19): las 5 pestanas viejas (Material para servicios, Material para instalaciones, Inventario,
  // Herramientas, Equipos instalados) ensenaban lo mismo. Ahora son 4 con contenido propio: Central (clave 'inventario',
  // se conserva), Oficina, Tecnicos e Instalados (clave 'equiposinstalados', se conserva). La migracion 108 pasa las
  // palomitas viejas a las nuevas.
  { id: 'almacen', label: 'Almacen', submodulos: [
    { id: 'inventario',            label: 'Central (bodega e inventario)' },
    { id: 'oficina',               label: 'Oficina (consumibles)' },
    { id: 'tecnicos',              label: 'Resguardos (material y herramientas a resguardo de cada persona)' },
    { id: 'equiposinstalados',     label: 'Instalados (series en sucursal)' },
    // INVENTARIO REAL (2026-10-17): quien es "compras" y ve el COSTO del inventario (y luego las
    // compras y el costo real por proyecto). Direccion lo ve siempre. No es un item del menu.
    { id: 'compras',               label: 'Compras (seccion Compras y ver costos)' },
  ]},
  { id: 'administracion', label: 'Administracion', submodulos: [
    { id: 'rrhh',               label: 'Recursos Humanos' },
    { id: 'finanzas',           label: 'Finanzas' },
    { id: 'usuarios',           label: 'Usuarios' },
    { id: 'configuracion',      label: 'Configuracion' },
    // AUDITOR (2026-10-21): tablero del auditor del almacen. Direccion lo ve por accesoTotal; el backend exige soloDireccion.
    { id: 'auditor',            label: 'Auditor del almacen (solo direccion)' },
    // SEGURIDAD-ENDPOINTS-ABIERTOS (2026-09-18): quien puede LEER el registro de accesos. Un
    // registro que dice quien entro, desde donde y a que hora es en si mismo informacion sensible.
    { id: 'registro-accesos',   label: 'Registro de accesos (seguridad)' },
    { id: 'busquedas-sin-resultado',   label: 'Busquedas sin resultado (La Tienda)' },
    { id: 'ajustes-vigilante',         label: 'Ajustes del vigilante de expedientes' },
    // RECUPERAR-IMPORTES (2026-09-28): la pantalla de captura en tabla de los importes de
    // facturas viejas. Es una vista de TODA la empresa y desde ella se escribe dinero.
    { id: 'capturar-importes',         label: 'Capturar importes de facturas' },
    { id: 'empresa',            label: 'Datos de la empresa' },
    // FLUJOS-FIJOS (Entrega 1): pantallas de workflows configurables dormidas.
    // { id: 'workflows',          label: 'Workflows' },
    // { id: 'workflows-personas', label: 'Personas por workflow' },
    // { id: 'estados',            label: 'Estados (catalogo)' },
    // TEMPORAL — quitar en Commit B5
    { id: 'test-subir-imagen',  label: 'Test SubirImagen' },
  ]},
  { id: 'dashboard', label: 'Dashboard', submodulos: [
    { id: 'general',     label: 'Dashboard general' },
    { id: 'operaciones', label: 'Dashboard operaciones' },
    { id: 'comercial',   label: 'Dashboard comercial' },
    { id: 'finanzas',    label: 'Dashboard finanzas' },
  ]},
  { id: 'cotizaciones', label: 'Cotizaciones', submodulos: [
    { id: 'tienda',         label: 'La Tienda' },
    { id: 'en-cotizacion',  label: 'En cotizacion' },
    { id: 'catalogo',       label: 'Mis Productos' },
    { id: 'listas',         label: 'Listas pactadas' },
    { id: 'colecciones',    label: 'Colecciones' },
    { id: 'mis-links',      label: 'Mis links' },
    { id: 'tipo-cambio',    label: 'Tipo de cambio' },
    { id: 'configuracion',  label: 'Configuracion' },
    { id: 'syscom',         label: 'Syscom' },
    { id: 'cambiar-estado', label: 'Cambiar estado de cotizacion' },
  ]},
  { id: 'aplicativos', label: 'Aplicativos', submodulos: [
    { id: 'expo', label: 'Expo Alianza' },
    { id: 'beeptv', label: 'BeepTV' },
  ]},
  { id: 'comercial', label: 'Comercial', submodulos: [
    { id: 'clientes',     label: 'Clientes' },
    { id: 'directorio',   label: 'Directorio' },
    { id: 'cotizaciones', label: 'Cotizaciones' },
    { id: 'prospectos',   label: 'Prospectos' },
  ]},
  { id: 'marketing', label: 'Marketing', submodulos: [
    { id: 'campanas',      label: 'Campanas' },
    { id: 'calendario',    label: 'Calendario' },
    { id: 'biblioteca',    label: 'Biblioteca' },
    { id: 'recursos',      label: 'Recursos' },
    { id: 'credenciales',  label: 'Credenciales' },
    { id: 'metricas',      label: 'Metricas' },
    { id: 'agentes',       label: 'Agentes IA' },
    { id: 'expo',          label: 'Expo Alianza' },
    { id: 'kiosko',        label: 'Kiosko' },
  ]},
];

// ============================================
// FUNCIONES DE VERIFICACION
// ============================================

// Verifica si el usuario tiene acceso TOTAL (rol direccion).
// Estos usuarios siempre devuelven true en puede() y puedeVer().
// FIX-PERM-MAPROL: aceptar tanto 'direccion' (BD) como 'Direccion'/'Dirección' (display).
// App.js mapea el rol via mapRol() para display, pero accesoTotal debe funcionar igual.
export function tieneAccesoTotal(usuario) {
  if (!usuario) return false;
  const rol = String(usuario.rol || '').toLowerCase();
  return rol === ROLES.DIRECCION || rol === 'direccion' || rol === 'dirección';
}

// Verifica si el usuario puede acceder a un permiso especifico.
// claveModulo formato: "modulo.submodulo" (ej: "mitrabajo.midia")
export function puede(usuario, claveModulo) {
  if (!usuario) return false;
  if (tieneAccesoTotal(usuario)) return true;
  if (!usuario.permisos || typeof usuario.permisos !== 'object') return false;
  return usuario.permisos[claveModulo] === true;
}

// Verifica si el usuario puede ver al MENOS un submodulo de un modulo.
// Util para mostrar/ocultar grupos completos del menu.
// moduloId: id del modulo (ej: "mitrabajo")
export function puedeVer(usuario, moduloId) {
  if (!usuario) return false;
  if (tieneAccesoTotal(usuario)) return true;
  if (!usuario.permisos || typeof usuario.permisos !== 'object') return false;
  return Object.keys(usuario.permisos).some(
    k => k.startsWith(`${moduloId}.`) && usuario.permisos[k] === true
  );
}

// ============================================
// GATE UNICO DE ACCESO (FIX-GATE-FLAT, 2026-07-04)
// ============================================
// TODA decision de "puede entrar a este modulo/submodulo?" pasa por aqui.
// La matriz granular de la pantalla Usuarios es la UNICA fuente de verdad:
// - clave con punto ("operaciones.calendario") -> permiso exacto (puede)
// - clave sin punto ("operaciones", secciones flat del sidebar) -> basta
//   tener AL MENOS un submodulo del modulo (puedeVer), consistente con el
//   criterio que usa el sidebar para mostrar la seccion.
// Bug historico que esto cierra: la seccion flat Expedientes navegaba a la
// clave 'operaciones' y RutaProtegida exigia esa clave EXACTA, que la matriz
// nunca escribe -> todo rol distinto de direccion quedaba bloqueado aunque
// tuviera todas las palomitas (caso Laura, Sesion #23).
export function puedeAcceder(usuario, clave) {
  if (!usuario) return false;
  if (tieneAccesoTotal(usuario)) return true;
  if (!clave) return false;
  return clave.includes('.') ? puede(usuario, clave) : puedeVer(usuario, clave);
}

// CALENDARIO-E1: ¿el usuario puede ver informacion FINANCIERA (cotizaciones,
// montos, margenes)? Espejo EXACTO del gate backend (permisosUsuario.js): quien
// ve todos los expedientes (gerente/operaciones/almacen) o finanzas/cotizaciones.
// El tecnico NO tiene ninguno -> no ve dinero. El backend lo hace cumplir con 403;
// esto es solo para ocultar la UI (tab Cotizaciones, montos) de forma coherente.
export function puedeVerFinanzas(usuario) {
  if (!usuario) return false;
  if (tieneAccesoTotal(usuario)) return true;
  const p = usuario.permisos;
  if (!p || typeof p !== 'object') return false;
  if (p['operaciones.expedientes-todos'] === true) return true;
  if (p['administracion.finanzas'] === true) return true;
  if (p['dashboard.finanzas'] === true) return true;
  if (p['comercial.cotizaciones'] === true) return true;
  return Object.keys(p).some(k => k.startsWith('cotizaciones.') && p[k] === true);
}

// Etiqueta humana de una clave de permiso, para mensajes de "Sin acceso".
// "operaciones.calendario" -> "Expedientes › Calendario"; "operaciones" -> "Expedientes".
export function labelDePermiso(clave) {
  if (!clave) return '';
  const [modId, subId] = String(clave).split('.');
  const mod = MODULOS.find(m => m.id === modId);
  if (!mod) return clave;
  if (!subId) return mod.label;
  const sub = mod.submodulos.find(s => s.id === subId);
  return sub ? `${mod.label} › ${sub.label}` : clave;
}

// Lista de claves de submodulos que el usuario PUEDE ver.
// Util para iterar y construir el menu dinamicamente.
export function permisosActivos(usuario) {
  if (!usuario) return [];
  if (tieneAccesoTotal(usuario)) {
    return MODULOS.flatMap(m => m.submodulos.map(s => `${m.id}.${s.id}`));
  }
  if (!usuario.permisos || typeof usuario.permisos !== 'object') return [];
  return Object.keys(usuario.permisos).filter(k => usuario.permisos[k] === true);
}

// ============================================
// COMPATIBILIDAD (DEPRECATED)
// ============================================
// Aliases mantenidos para no romper Dashboard.js ni UsuarioContext.js hasta
// que PERM-3 los refactorice a usar puede() / puedeVer() / permisosActivos()
// directamente.

// DEPRECATED: usar puede() en su lugar.
export function tienePermiso(usuario, claveModulo) {
  return puede(usuario, claveModulo);
}

// DEPRECATED: usar puedeVer() en su lugar.
export function puedeVerSeccion(usuario, seccionId) {
  return puedeVer(usuario, seccionId);
}

// DEPRECATED: usar permisosActivos() en su lugar.
export function obtenerPermisos(usuario) {
  return permisosActivos(usuario);
}
